import { get, post } from './API';

// Thin wrapper over the locked /accounts contract. Mirrors the
// minimal style of PartnersService — list/create/update only, no
// optimistic state. Endpoints:
//   GET  /accounts                       → { data: Account[] }
//   POST /accounts                       → { data: Account }
//   POST /accounts?action=update         → { data: Account }
//
// The list response is sorted by is_active DESC, name ASC by the
// backend; callers should generally pass an explicit { is_active: true }
// filter when they only need pickable accounts.
const AccountsService = {
  list: async (filters = {}) => {
    // Strip empty/undefined keys so we don't send ?is_active= in the URL,
    // which the backend could interpret as a real filter for an empty
    // string. Same convention as PaymentsService.list.
    const params = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== undefined && v !== null && v !== ''),
    );
    const response = await get('/accounts', params);
    return response.data?.data ?? [];
  },

  create: async (payload) => {
    const response = await post('/accounts', payload);
    return response.data?.data;
  },

  // POST /accounts?action=update — backend requires account_id in the
  // body alongside the patch. Pass `params` (axios merges into the URL)
  // for the same reason PaymentsService.reassignPayment does.
  update: async (accountId, patch) => {
    const response = await post(
      '/accounts',
      { account_id: accountId, ...patch },
      {},
      { action: 'update' },
    );
    return response.data?.data;
  },
};

export default AccountsService;
